import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideChildRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { PasswordResetQrcodeComponent } from './dynamic-components/password-reset-qrcode/password-reset-qrcode.component';
import * as i0 from "@angular/core";
// TODO: this is pretty specific to mpf managers... should not be that way in a common feature.
let UsersPasswordResetQrcodeFrontendFeature = /*#__PURE__*/(() => {
  let UsersPasswordResetQrcodeFrontendFeature = class UsersPasswordResetQrcodeFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/users-password-reset-qrcode/frontend","featureId":"common-users-password-reset-qrcode"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineWidgets([{
        type: 'Content',
        id: 'PasswordResetQrCodeInfoComponent',
        positionIds: ['common/auth-strategy-credentials/password-reset/top'],
        load: () => import('./dynamic-components/password-reset/password-reset.component').then(bundle => bundle.PasswordResetQrCodeInfoComponent)
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUsersPasswordResetQrcodeFrontendFeature_BaseFactory;
        return function UsersPasswordResetQrcodeFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵUsersPasswordResetQrcodeFrontendFeature_BaseFactory || (ɵUsersPasswordResetQrcodeFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(UsersPasswordResetQrcodeFrontendFeature)))(__ngFactoryType__ || UsersPasswordResetQrcodeFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UsersPasswordResetQrcodeFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideChildRoutes([{
          path: 'user/password-reset-qrcode',
          component: PasswordResetQrcodeComponent
        }])]
      });
    }
  };
  UsersPasswordResetQrcodeFrontendFeature = __decorate([ClassName("UsersPasswordResetQrcodeFrontendFeature")], UsersPasswordResetQrcodeFrontendFeature);
  return UsersPasswordResetQrcodeFrontendFeature;
})();
export { UsersPasswordResetQrcodeFrontendFeature };